import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as pbi from 'powerbi-client';
import * as pbimodels from 'powerbi-models';
import { MatDialog } from '@angular/material/dialog';

import { ReportService } from '../../services/report/report.service';
import { UserService } from '../../services/user/user.service';
import { GoogleAnalyticsService } from '../../services/google-analytics/google-analytics.service';
import { AuditLogService } from '../../services/audit/audit-log.service';
import { Logging } from '../../utils/logging';

let loadedResolve,
  reportLoaded = new Promise((res, rej) => {
    loadedResolve = res;
  });
let renderedResolve,
  reportRendered = new Promise((res, rej) => {
    renderedResolve = res;
  });

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  standalone: false,
})
export class ReportsComponent implements OnInit, OnDestroy {
  private reportkey: string;
  private sub: any;
  public report: pbi.Report;
  public isLoading: boolean;
  public isAdminUser: boolean;

  constructor(
    private route: ActivatedRoute,
    private reportSerice: ReportService,
    public dialog: MatDialog,
    public gaService: GoogleAnalyticsService,
    public auditService: AuditLogService,
    private router: Router,
    public userService: UserService,
  ) {
    userService.isAdmin.subscribe(v => {
      this.isAdminUser = v;
    });
  }

  ngOnInit() {
    if (!this.isAdminUser) this.router.navigate(['unauthorized']);
    this.getAndDisplayReport();
  }

  getAndDisplayReport() {
    let t = this;
    this.isLoading = true;
    this.sub = this.route.params.subscribe(params => {
      this.reportkey = params['id'];
      this.reportSerice.getReportUrl(this.reportkey).then(data => {
        const embedParams = JSON.parse(data);
        const reportLoadConfig = {
          type: 'report',
          tokenType: pbimodels.TokenType.Embed,
          accessToken: embedParams.EmbedToken.Token,
          embedUrl: embedParams.EmbedReport[0].EmbedUrl,
          settings: {
            panes: {
              filters: {
                visible: false,
              },
              pageNavigation: {
                visible: false,
              },
            },
            layoutType: pbi.models.LayoutType.Custom,
            customLayout: {
              displayOption: pbi.models.DisplayOption.FitToPage,
            },
          },
        };
        const powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory,
        );

        powerbi.reset(this.getReportElement());
        // Embed Power BI report when Access token and Embed URL are available
        this.report = powerbi.embed(
          this.getReportElement(),
          reportLoadConfig,
        ) as pbi.Report;

        // Triggers when a report schema is successfully loaded
        this.report.on('loaded', () => {
          loadedResolve();
        });

        // Triggers when a report is successfully embedded in UI
        this.report.on('rendered', () => {
          t.isLoading = false;
          renderedResolve();
        });

        // Clear any other error handler events
        this.report.off('error');

        // Handle embed errors
        this.report.on('error', event => {
          Logging.error(event.detail);
        });
      });
    });
  }

  private getReportElement(): HTMLElement {
    return document
      .getElementsByClassName('report-frame')
      .item(0) as HTMLElement;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
